export enum EJobState {
    None,
    Waiting,
    Executed
}